(function () {
  'use strict';

  function buildHiResSrcset(img) {
    var srcset = img.getAttribute('data-srcset') || '';
    if (!srcset) return '';

    if (srcset.indexOf(' 900w') === -1) {
      var match600 = srcset.match(/([^,\s]+)\s+600w/);
      if (match600 && match600[1]) {
        var url600 = match600[1];
        var url900 = url600.replace(/_600x(?=\.)/, '_900x');
        if (url900 !== url600) {
          srcset += ', ' + url900 + ' 900w';
        }
      }
    }
    return srcset;
  }

  function upgradeHoverImage(img) {
    if (!img || img.getAttribute('data-sockette-hires') === '1') return;

    var srcset = buildHiResSrcset(img);
    if (!srcset) return;

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', '(min-width: 1200px) 380px, (min-width: 769px) 33vw, 50vw');
    img.setAttribute('decoding', 'async');
    img.setAttribute('fetchpriority', 'low');
    img.setAttribute('data-sockette-hires', '1');
  }

  function initHoverImageQuality() {
    var images = document.querySelectorAll('.reveal .hidden img[data-srcset]');
    if (!images.length) return;

    document.addEventListener('pointerover', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var reveal = target.closest('.reveal');
      if (!reveal) return;
      upgradeHoverImage(reveal.querySelector('.hidden img[data-srcset]'));
    }, true);

    document.addEventListener('touchstart', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var reveal = target.closest('.reveal');
      if (!reveal) return;
      upgradeHoverImage(reveal.querySelector('.hidden img[data-srcset]'));
    }, { passive: true, capture: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          upgradeHoverImage(card.querySelector('.reveal .hidden img[data-srcset]'));
          obs.unobserve(card);
        });
      }, { rootMargin: '450px 0px' });

      images.forEach(function (img) {
        var card = img.closest('.product-grid-item');
        if (card) observer.observe(card);
      });
    } else {
      images.forEach(upgradeHoverImage);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverImageQuality);
  } else {
    initHoverImageQuality();
  }
})();